import { render, staticRenderFns } from "./CommApproval.vue?vue&type=template&id=744aab4d&scoped=true"
import script from "./CommApproval.vue?vue&type=script&lang=js"
export * from "./CommApproval.vue?vue&type=script&lang=js"
import style0 from "./CommApproval.vue?vue&type=style&index=0&id=744aab4d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744aab4d",
  null
  
)

export default component.exports